import React from 'react';
import { useParams } from 'react-router-dom';
import PeopleData from '../../services/people-service';
import SociogramService from '../../services/socio-service';
import './sociogram.css';
import toast from 'react-hot-toast';

// Create a wrapper component that uses hooks
function UpdateSociogramFormWrapper(props) {
  const { sociogramId } = useParams();
  return <UpdateSociogramForm {...props} sociogramId={sociogramId} />;
}

export class UpdateSociogramForm extends React.Component {

  constructor() {
    super()
    this.state = {
      loading: true
    }
  }

  async componentDidMount() {
    const { accessToken, sociogramId } = this.props;
    this.setState({
      accessToken,
      sociogramId
    })
    
    try {
      // Fetch all people
      const peopleData = await PeopleData.getData(accessToken);
      
      // Fetch existing sociogram data
      const sociogramData = await SociogramService.getSociogram(sociogramId, accessToken);
      
      // Initialize includedPeople with existing people in the sociogram
      this.includedPeople = sociogramData.people || [];
      
      this.setState({ 
        peopleData: peopleData,
        sociogramData: sociogramData,
        loading: false
      });
      
      // Set checkboxes for already included people
      this.setInitialCheckboxes();
      
    } catch (error) {
      toast.error('Failed to load sociogram data');
      console.error("Error loading sociogram:", error);
      this.setState({ loading: false });
    }
  }

  includedPeople = [];

  setInitialCheckboxes = () => {
    // Wait for render to complete
    setTimeout(() => {
      this.includedPeople.forEach(personId => {
        const checkbox = document.getElementById(personId);
        if (checkbox) {
          checkbox.checked = true;
        }
      });
    }, 100);
  }

  handlePersonCheck = event => {
    if (event.target.checked) {
      this.includedPeople.push(event.target.name);
    } else {
      var index = this.includedPeople.indexOf(event.target.name);
      this.includedPeople.splice(index, 1);
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      // Get form data
      const data = new FormData(event.target);
      const formData = {
        id: data.get('id'),
        name: data.get('name'),
        password: data.get('password'),
        people: this.includedPeople
      };
      
      // Use access token and sociogramId from state
      const { accessToken, sociogramId } = this.state;
      
      // Call the update method
      await SociogramService.updateSociogram(sociogramId, formData, accessToken);
      
      // Handle success
      toast.success('Successfully updated Sociogram');
      
    } catch (error) {
      // Handle error
      toast.error(error.message);
      console.error("Error updating sociogram:", error);
    }
  }

  selectAll = event => {
    this.includedPeople = [];
    for (var i = 0; i < this.state.peopleData.length; i++) {
      this.includedPeople.push(this.state.peopleData[i].id);
    }
    this.toggleCheckboxes(true);
  }

  deselectAll = event => {
    this.toggleCheckboxes(false);
    this.includedPeople = [];
  }

  toggleCheckboxes(select) {
    var x = document.getElementsByClassName("checkbox");
    for (var i = 0; i < x.length; i++) {
      x[i].checked = select;
    }
    return false;
  }

  render() {
    const { loading, peopleData, sociogramData } = this.state;

    if (loading) {
      return (<div>Loading...</div>);
    }

    if (!peopleData) {
      return (<div>You need to set people up before you can update a sociogram</div>);
    }

    let userRows = [];
    for (var i = 0; i < peopleData.length; i++) {
      userRows.push(
        <div className="col-md-6" key={peopleData[i].id}>
          <input
            type="checkbox"
            className="form-control checkbox"
            id={peopleData[i].id}
            name={peopleData[i].id}
            onChange={this.handlePersonCheck}
          />
          {peopleData[i].givenName} {peopleData[i].surname}
        </div>
      )
    }

    return (
      <div>
        <h1>Update Sociogram</h1>
        <form className="form-horizontal" id="update-sociogram" onSubmit={this.handleSubmit}>
          <div className="form-group padding-10">
            <div className="col-md-6">
              <input type="hidden" name="id" defaultValue={sociogramData?.id || ''} />
              <input
                type="text"
                className="form-control"
                required
                id="name"
                placeholder="Sociogram Name"
                name="name"
                defaultValue={sociogramData?.name || ''}
              />
            </div>
            <div className="col-md-6">
              <p>
                (Optional) Update the password for your Sociogram. Leave blank to keep existing password:
              </p>
              <input
                type="text"
                className="form-control"
                id="password"
                placeholder="Sociogram Password"
                name="password"
              />
            </div>
            <div className="col-md-6">
              Select people to invite to this sociogram:
              <div className="form-group">
                <div className="col-md-12">
                  <button
                    type="button"
                    onClick={this.selectAll}
                    className="btn btn-primary btn-block contact">
                    Select All
                  </button>
                  <button
                    type="button"
                    onClick={this.deselectAll}
                    className="btn btn-primary btn-block contact">
                    Deselect All
                  </button>
                </div>
              </div>
              {userRows}
            </div>
          </div>
          <div className="form-group">
            <div className="col-md-12">
              <button
                type="submit"
                className="btn btn-primary btn-block contact">
                Update Sociogram
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
export default UpdateSociogramFormWrapper;